import { UI, HStack, VStack, Stack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import {
  ButtonSkeleton,
  DetailsSkeleton,
  DoubleTextSkeleton,
  InputSkeleton,
  RiskSkeleton,
  TextSkeleton,
} from '../../../../AssetsLoading';
import { LateralBar } from '../../../components/LateralBar';

export const ListLoadingItemDesktop: React.FC = () => {
  const { selectedTab } = useGlobalAssetContext();

  const infos = [
    { label: 'Risco', value: <RiskSkeleton /> },
    { label: 'Vencimento', value: <TextSkeleton w="80%" /> },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']} h="96px">
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <HStack justifyContent="space-between" alignItems="center" w="full">
        <HStack space={Spacing['inline.xxxs']} alignItems="center" w="15%">
          <DetailsSkeleton />
          <DoubleTextSkeleton w="80%" />
        </HStack>
        {infos.map(({ label, value }) => (
          <VStack space={Spacing['stack.quarck']} key={label}>
            <UI.Text color="neutral.black" variant="semibold">
              {label}
            </UI.Text>
            {value}
          </VStack>
        ))}

        <Stack w="10%">
          <DoubleTextSkeleton w="100%" />
        </Stack>
        <Stack w="10%">
          <DoubleTextSkeleton w="100%" />
        </Stack>

        <VStack space={Spacing['stack.quarck']} maxW="200px" w="full">
          <UI.Text color="neutral.black" variant="semibold">
            Valor a aplicar
          </UI.Text>
          <InputSkeleton />
        </VStack>

        <Stack w="10%">
          <ButtonSkeleton />
        </Stack>
      </HStack>
    </TableContent>
  );
};
